import { render, staticRenderFns } from "./class_list.vue?vue&type=template&id=48f4d404&scoped=true"
import script from "./class_list.vue?vue&type=script&lang=js"
export * from "./class_list.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/class-management.scss?vue&type=style&index=0&id=48f4d404&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f4d404",
  null
  
)

export default component.exports